import { Point } from "./Point";
export class Bezier {
    static getPoints(pList, inSertCount = 5, count = 2, out) {
        out = out || [];
        let len = pList.length;
        if (len < (count + 1) * 2)
            return out;
        switch (count) {
            case 2:
                _calFun = getPoint2;
                break;
            case 3:
                _calFun = getPoint3;
                break;
            default:
                return [];
        }
        while (tmpPoints.length <= count) {
            tmpPoints.push(new Point());
        }
        for (let i = 0; i < count * 2; i += 2) {
            _switchPoint(pList[i], pList[i + 1]);
        }
        for (let i = count * 2; i < len; i += 2) {
            _switchPoint(pList[i], pList[i + 1]);
            if ((i / 2) % count == 0)
                insertPoints(inSertCount, out);
        }
        return out;
    }
    static getRate(t, px0, py0, px1, py1) {
        let key = _getBezierParamKey(px0, py0, px1, py1);
        let vKey = key * 100 + t;
        if (_bezierResultCache[vKey])
            return _bezierResultCache[vKey];
        let points;
        if (_bezierPointsCache[key])
            points = _bezierPointsCache[key];
        else {
            var controlPoints;
            controlPoints = [0, 0, px0, py0, px1, py1, 1, 1];
            points = Bezier.getPoints(controlPoints, 100, 3);
            _bezierPointsCache[key] = points;
        }
        let len = points.length;
        for (let i = 0; i < len; i += 2) {
            if (t <= points[i]) {
                _bezierResultCache[vKey] = points[i + 1];
                return points[i + 1];
            }
        }
        _bezierResultCache[vKey] = 1;
        return 1;
    }
}
const tmpPoints = [new Point(), new Point(), new Point()];
var _calFun = getPoint2;
const _bezierResultCache = {};
const _bezierPointsCache = {};
function _switchPoint(x, y) {
    let tPoint = tmpPoints.shift();
    tPoint.setTo(x, y);
    tmpPoints.push(tPoint);
}
function getPoint2(t, rst) {
    var p1 = tmpPoints[0];
    var p2 = tmpPoints[1];
    var p3 = tmpPoints[2];
    var lineX = Math.pow((1 - t), 2) * p1.x + 2 * t * (1 - t) * p2.x + Math.pow(t, 2) * p3.x;
    var lineY = Math.pow((1 - t), 2) * p1.y + 2 * t * (1 - t) * p2.y + Math.pow(t, 2) * p3.y;
    rst.push(lineX, lineY);
}
function getPoint3(t, rst) {
    var p1 = tmpPoints[0];
    var p2 = tmpPoints[1];
    var p3 = tmpPoints[2];
    var p4 = tmpPoints[3];
    var lineX = Math.pow((1 - t), 3) * p1.x + 3 * p2.x * t * (1 - t) * (1 - t) + 3 * p3.x * t * t * (1 - t) + p4.x * Math.pow(t, 3);
    var lineY = Math.pow((1 - t), 3) * p1.y + 3 * p2.y * t * (1 - t) * (1 - t) + 3 * p3.y * t * t * (1 - t) + p4.y * Math.pow(t, 3);
    rst.push(lineX, lineY);
}
function insertPoints(count, rst) {
    var i;
    count = count > 0 ? count : 5;
    var dLen;
    dLen = 1 / count;
    for (i = 0; i <= 1; i += dLen) {
        _calFun(i, rst);
    }
}
function _getBezierParamKey(px0, py0, px1, py1) {
    return (((px0 * 100 + py0) * 100 + px1) * 100 + py1) * 100;
}
